import { QUERY_STRING_CONSTS } from '../../Analytics/models/Enums';
import { MiscUtils } from '../utilites/MiscUtils';
import parser from 'ua-parser-js';
export var DeviceType;
(function (DeviceType) {
  DeviceType["DESKTOP"] = "pc";
  DeviceType["TABLET"] = "tablet";
  DeviceType["MOBILE"] = "phone";
})(DeviceType || (DeviceType = {}));
var DeviceDetector = /** @class */function () {
  function DeviceDetector() {
    this.p = new parser.UAParser();
  }
  DeviceDetector.prototype.DetectDevice = function () {
    var deviceInfo = this.p.getDevice();
    switch (deviceInfo.type) {
      case 'mobile':
        return DeviceType.MOBILE;
      case 'tablet':
        return DeviceType.TABLET;
      default:
        return DeviceType.DESKTOP;
    }
  };
  DeviceDetector.prototype.DetectBrowser = function () {
    var browserInfo = this.p.getBrowser();
    var result = {
      name: browserInfo.name,
      version: browserInfo.version,
      major: browserInfo.major
    };
    return result;
  };
  DeviceDetector.prototype.DetectOS = function () {
    var osInfo = this.p.getOS();
    var result = {
      name: osInfo.name,
      version: osInfo.version
    };
    return result;
  };
  //req: Request from Express
  DeviceDetector.prototype.getDeviceType = function (req) {
    var PlatformTypeQueryKey = 'ark__platformtype';
    var platform = (req === null || req === void 0 ? void 0 : req.query[PlatformTypeQueryKey]) || DeviceType.DESKTOP;
    if (platform === 'phone' || platform === 'mobile') {
      platform = DeviceType.MOBILE;
    }
    return platform;
  };
  //
  // Get bookmark type desktop,android,ios
  //
  DeviceDetector.prototype.getBookmarkType = function () {
    if (MiscUtils.isServer) {
      return null;
    }
    if (sessionStorage.getItem('arkBookmarkType')) {
      return sessionStorage.getItem('arkBookmarkType');
    }
    if (window.location.href.indexOf("".concat(QUERY_STRING_CONSTS.UTM_SOURCE, "=desktopIcon")) !== -1 || this.getDeviceType() && (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true)) {
      return 'desktop';
    }
    if (window.navigator.standalone === true && this.DetectBrowser().name === 'Safari') {
      return 'ios';
    }
    if (window.matchMedia('(display-mode: standalone)').matches) {
      if (this.DetectBrowser().name === 'Safari') {
        return 'ios';
      }
      return 'android';
    }
    return '';
  };
  return DeviceDetector;
}();
export { DeviceDetector };